import FloatingSupport from '~/components/_core/ui/floating-support/index.vue';
import HeaderDefault from '@/components/_core/ui/header/index.vue';
import Vue from 'vue';
import MenuSidebarV3 from '~/components/_core/ui/menu-sidebar-v3/index.vue';
import MenuSidebarDefault from '~/components/_core/ui/menu-sidebar/index.vue';
import { SAFEA_V3_ENABLED, SAFEA_VERSION } from '~/constants/_core/safea-v3';
import sentryMixin from '~/mixins/_core/sentry.mixin';
import getConfig from '~/sidebar.config';

export default Vue.extend({
  name       : 'DefaultLayout',
  components : {
    FloatingSupport,
    HeaderDefault,
    MenuSidebarV3,
    MenuSidebarDefault
  },
  mixins: [sentryMixin],
  data() {
    const {
      allowSearch,
      items
    } = getConfig({ ...this.$nuxt.context, i18n: this.$i18n });
    return {
      expandOnHover : false,
      type          : 'authenticated',
      subscribe     : null,
      legacyLayout  : !this.$store.state._core.application.layoutv2,
      menuItemsV3   : items,
      allowSearch
    };
  },
  computed: {
    disableHeader() {
      return this.$route.query.disableHeader === 'true';
    },
    isV3() {
      if (SAFEA_VERSION === 'v3') {
        return true;
      }

      const hasV3MenuItems = this.menuItemsV3.some(item => item.title && (item.children || item.link));
      return SAFEA_V3_ENABLED && hasV3MenuItems;
    }
  },
  watch: {
    '$vuetify.breakpoint.smAndDown'(val) {
      this.expandOnHover = !val;
    }
  },
  beforeMount() {
    this.subscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === '_core/application/SET_LAYOUT_V2') {
        this.legacyLayout = !state._core.application.layoutv2;
      }
    });
  },
  beforeDestroy() {
    if (this.subscribe) {
      this.subscribe();
    }
  }
});
